import { IonRow, IonCol, IonIcon } from '@ionic/react';
import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { RootState } from '../../models/RootState';
import {
  fetchOpenBets,
  fetchMultiMarketEventData,
  getSecondaryMarketsByEvent,
  getSecondaryMatchOddsByEvent,
  getBookmakerMarketsByEvent,
  getFancyMarketsByEvent,
  getHouseIdFromToken,
  getParentIdFromToken,
  fetchBalance,
} from '../../store';
import './ExchangeAllMarkets.scss';
import ExchMultiMarket from './ExchangeMultiMarket';
import { UserBet } from '../../models/UserBet';
import CompetitionsMenu from '../../components/ExchCompetitionsMenu/ExchCompetitionsMenu';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Tab,
  Tabs,
  Collapse,
  Tooltip,
  Button,
} from '@material-ui/core';
import SuccessIcon from '@material-ui/icons/CheckCircleOutline';
import ErrorIcon from '@material-ui/icons/ErrorOutline';
import InfoRounded from '@material-ui/icons/InfoRounded';
import { NavLink, useLocation } from 'react-router-dom';
import ExchBetslip from '../../components/ExchBetslip/ExchBetslip';
import ExchOpenBets from '../../components/ExchOpenBets/ExchOpenBets';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { PlaceBetRequest } from '../../models/BsData';
import { useMarketLocalState } from '../../hooks/storageHook';
import TabPanel from '../../components/TabPanel/TabPanel';
import { isIOS } from 'react-device-detect';
import SVLS_API from '../../svls-api';
import { BRAND_NAME } from '../../constants/Branding';
import SEO from '../../components/SEO/Seo';
import {
  isPushNotificationConnected,
  subscribeWsForNotifications,
  subscribeWsForNotificationsPerAdmin,
  unsubscribePNWsforEvents,
} from '../../webSocket/webSocket';
import moment from 'moment';
import { toast } from 'react-toastify';
import {
  betStatus,
  clearBetStatusResponse,
  clearExchcngeBets,
  setBettingInprogress,
} from '../../store/exchBetslip/exchBetslipActions';
import { BET_TIMEOUT } from '../../constants/CommonConstants';

type StoreProps = {
  fetchOpenBets: (eventId: string[] | string, sportId?: string) => void;
  fetchMultiMarketEventData: () => void;
  marketData: any;
  secondaryMultiMatchOdds: any;
  secondaryMultiMarket: any;
  openBets: UserBet[];
  totalOrders: number;
  loggedIn: boolean;
  bets: PlaceBetRequest[];
  triggerFetchMarkets: number;
  triggerFetchOrders: number;
  houseId: string;
  parentId: string;
  accountId: string;
  triggerBetStatus: number;
  betStatusResponse: any;
  clearExchangeBets: () => void;
  setBettingInprogress: (val: boolean) => void;
  clearBetStatusResponse: () => void;
};

const MultiMarketView: React.FC<StoreProps> = (props) => {
  const {
    fetchMultiMarketEventData,
    marketData,
    secondaryMultiMatchOdds,
    secondaryMultiMarket,
    loggedIn,
    openBets,
    totalOrders,
    fetchOpenBets,
    bets,
    triggerFetchMarkets,
    triggerFetchOrders,
    houseId,
    parentId,
    accountId,
    triggerBetStatus,
    betStatusResponse,
    clearExchangeBets,
    setBettingInprogress,
    clearBetStatusResponse,
  } = props;
  const [openBetslip, setOpenBetslip] = useState<boolean>(true);
  const [tabVal, setTabVal] = useState(0);
  const isMobile = window.innerWidth > 1120 ? false : true;
  const [exposureMap, setExposureMap] = useState(null);
  const [enableFetchOrders, setEnableFetchOrders] = useState<boolean>(false);
  const pathLocation = useLocation();
  const [startTime, setStartTime] = useState<Date>();
  const [fetchOpenOrders, setFetchOpenOrders] = useState<number>(null);
  const [addNewBet, setAddNewBet] = useState<boolean>(true);
  const intervalRef = useRef(null);
  const isFirstRender = useRef(true);
  const isFirstRenderStartTime = useRef(true);

  useEffect(() => {
    fetchMultiMarketEventData();
  }, [triggerFetchMarkets]);
  const [multiMarketData] = useMarketLocalState();

  useEffect(() => {
    if (multiMarketData?.length) {
      let eventIds = [];
      multiMarketData.forEach((item) => {
        eventIds.push(item?.eventId);
      });
      fetchOpenBets(eventIds);
      fetchOpenBetsRisk();
    }
    setEnableFetchOrders(true);
  }, [multiMarketData]);

  useEffect(() => {
    if (loggedIn && enableFetchOrders && multiMarketData?.length) {
      let eventIds = [];
      multiMarketData.forEach((item) => {
        eventIds.push(item?.eventId);
      });
      setTimeout(() => {
        fetchOpenBets(eventIds);
        fetchOpenBetsRisk();
      }, 1000);
    }
    // }, [loggedIn, triggerFetchOrders, fetchOpenOrders]);
  }, [loggedIn, triggerFetchOrders]);

  useEffect(() => {
    if (totalOrders && !isMobile) {
      setTabVal(1);
    }
  }, [totalOrders]);
  useEffect(() => {
    if (bets.length > 0) {
      setTabVal(0);
    }
  }, [bets]);

  useEffect(() => {
    if (loggedIn) {
      unsubscribePNWsforEvents(houseId);
      unsubscribePNWsforEvents(parentId);
      subscribeWsForNotificationsPerAdmin(true, houseId, parentId, accountId);
      subscribeWsForNotifications(true, houseId);
      return () => {
        unsubscribePNWsforEvents(houseId);
        unsubscribePNWsforEvents(parentId);
        if (!window.location.pathname.includes('multi-market')) {
          subscribeWsForNotificationsPerAdmin(
            false,
            houseId,
            parentId,
            accountId
          );
          subscribeWsForNotifications(false, houseId);
        }
      };
    }
  }, [isPushNotificationConnected(), loggedIn]);

  const fetchOpenBetsRisk = async () => {
    try {
      if (!multiMarketData?.length) {
        return;
      }

      let eventIds = [];
      let marketIds = [];
      multiMarketData.forEach((item) => {
        eventIds.push(item?.eventId);
        marketIds.push(item?.marketId);
      });

      const response = await SVLS_API.get(
        '/reports/v2/risk-management/user-risk',
        {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
          },
          params: {
            eventId: Array.isArray(eventIds) ? eventIds.join(',') : eventIds,
            marketId: Array.isArray(marketIds)
              ? marketIds.join(',')
              : marketIds,
          },
        }
      );
      setExposureMap(response.data.marketExposureMap);
    } catch (e) {
      console.log(e);
    }
  };

  // useEffect(() => {
  //   if (betStatusResponse === null) {
  //     return;
  //   }

  //   switch (betStatusResponse.status) {
  //     case 'IN_PROGRESS': {
  //       toast.info(
  //         <div>
  //           <InfoRounded />
  //           {betStatusResponse.message}
  //         </div>
  //       );
  //       break;
  //     }
  //     case 'SUCCESS': {
  //       toast.success(
  //         <div>
  //           <SuccessIcon />
  //           {betStatusResponse.message}
  //         </div>
  //       );
  //       if (addNewBet) {
  //         setFetchOpenOrders(moment.now());
  //       }
  //       fetchBalance();
  //       break;
  //     }
  //     case 'FAIL': {
  //       toast.error(
  //         <div>
  //           <ErrorIcon /> Bet failed - {betStatusResponse.message}
  //         </div>
  //       );
  //       break;
  //     }
  //   }

  //   setBettingInprogress(false);
  //   if (bets[0]?.amount) {
  //     clearExchangeBets();
  //   }
  //   clearBetStatusResponse();
  // }, [betStatusResponse]);

  // useEffect(() => {
  //   if (isFirstRender.current) {
  //     isFirstRender.current = false;
  //     return;
  //   }
  //   clearInterval(intervalRef.current);
  //   betStatus();
  // }, [triggerBetStatus]);

  // useEffect(() => {
  //   if (isFirstRenderStartTime.current) {
  //     isFirstRenderStartTime.current = false;
  //     return;
  //   }

  //   intervalRef.current = setInterval(() => {
  //     betStatus();
  //     clearInterval(intervalRef.current);
  //   }, BET_TIMEOUT);

  //   return () => clearInterval(intervalRef.current);
  // }, [startTime]);

  // useEffect(() => {
  //   setBettingInprogress(false);
  //   if (bets[0]?.amount) {
  //     clearExchangeBets();
  //   }
  //   clearBetStatusResponse();
  // }, []);

  return (
    <>
      <SEO
        title={BRAND_NAME}
        name={'Multi-market'}
        description={'Multi-market page'}
        type={'multimarket'}
        link={pathLocation?.pathname}
      />
      <IonRow className="eam-ctn">
        <IonCol className="eam-competitions-menu-section">
          <div className="sticky-col">
            <CompetitionsMenu />
          </div>
        </IonCol>
        <IonCol className="eam-events-table-section">
          <div className="event-name multi-market-heading">MultiMarket</div>
          {multiMarketData?.length &&
          marketData &&
          Object.keys(marketData)?.length ? (
            Object.keys(marketData).map((item) => {
              return (
                <ExchMultiMarket
                  key={item}
                  loggedIn={loggedIn}
                  eventData={marketData[item] ?? {}}
                  openBets={openBets}
                  secondaryMarkets={getSecondaryMarketsByEvent(
                    secondaryMultiMarket,
                    item
                  )}
                  secondaryMatchOdds={getSecondaryMatchOddsByEvent(
                    secondaryMultiMatchOdds,
                    item
                  )}
                  bmMData={getBookmakerMarketsByEvent(
                    secondaryMultiMarket,
                    item
                  )}
                  eventId={marketData[item]?.eventId}
                  isMultiMarket={true}
                  exposureMap={exposureMap ? exposureMap : null}
                />
              );
            })
          ) : (
            <div className="no-data multimarket-no-data">
              There are currently no followed multi markets.
            </div>
          )}
        </IonCol>

        {!isMobile ? (
          <IonCol className="stream-section">
            <div className="sticky-col bet-slip-open-bets-ctn">
              <Tabs
                value={tabVal}
                className="eam-all-markets-header-tabs"
                onChange={(_, newValue) => {
                  setTabVal(newValue);
                }}
              >
                <Tab label={`Bet Slip (${bets.length})`} value={0} />
                {/* <Tab
                      label="Live Stream"
                      value={1}
                      disabled={
                        !(
                          eventData &&
                          (eventData.inPlay || eventData.matchOdds.inplay)
                        )
                      }
                    /> */}
                <Tab
                  label={'Open Bets (' + totalOrders + ')'}
                  value={1}
                  // disabled={openBets.length < 1}
                />
              </Tabs>

              <TabPanel
                value={tabVal}
                index={0}
                className="event-stat-mobile-ctn"
              >
                {bets.length > 0 && !isMobile ? (
                  <ExchBetslip
                    setBetStartTime={(date) => setStartTime(date)}
                    setAddNewBet={(val) => setAddNewBet(val)}
                  />
                ) : (
                  <>
                    <div className="no-bet-data">Place bet to see it here</div>
                  </>
                )}
              </TabPanel>
              <TabPanel
                value={tabVal}
                index={1}
                className="event-stat-mobile-ctn"
              >
                <div className="btn-background">
                  <div className="btn-mybets">
                    <NavLink to="/my_bets">
                      <Button>View All</Button>
                    </NavLink>
                  </div>
                </div>
                {openBets.length > 0 && loggedIn ? (
                  <ExchOpenBets />
                ) : (
                  <>
                    <div className="no-bet-data">No open bets to show</div>
                  </>
                )}
              </TabPanel>
            </div>
          </IonCol>
        ) : null}

        {bets.length > 0 ? (
          <div
            className={
              isIOS
                ? 'betslip-section ios-betslip mob-betslip-section'
                : 'betslip-section mob-betslip-section'
            }
          >
            <Accordion
              className="stream-accordion"
              expanded={openBetslip}
              onChange={(_, expanded) => setOpenBetslip(expanded)}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon className="expand-icon" />}
                aria-controls="panel1a-content"
                className="stream-header"
              >
                Bet Slip ({bets.length})
              </AccordionSummary>
              <AccordionDetails className="stream-body">
                <Tabs
                  value={tabVal}
                  className="eam-all-markets-header-tabs"
                  onChange={(_, newValue) => {
                    setTabVal(newValue);
                  }}
                >
                  <Tab label={`Bet Slip (${bets.length})`} value={0} />
                  {/* <Tab
                      label="Live Stream"
                      value={1}
                      disabled={
                        !(
                          eventData &&
                          (eventData.inPlay || eventData.matchOdds.inplay)
                        )
                      }
                    /> */}
                  <Tab
                    label={'Open Bets (' + totalOrders + ')'}
                    value={1}
                    // disabled={openBets.length < 1}
                  />
                </Tabs>

                <TabPanel
                  value={tabVal}
                  index={0}
                  className="event-stat-mobile-ctn"
                >
                  {bets.length > 0 && isMobile ? (
                    <ExchBetslip
                      setBetStartTime={(date) => setStartTime(date)}
                      setAddNewBet={(val) => setAddNewBet(val)}
                    />
                  ) : (
                    <>
                      <div className="no-bet-data">
                        Place bet to see it here
                      </div>
                    </>
                  )}
                </TabPanel>
                <TabPanel
                  value={tabVal}
                  index={1}
                  className="event-stat-mobile-ctn"
                >
                  <div className="btn-background">
                    <div className="btn-mybets">
                      <NavLink to="/my_bets">
                        <Button>View All</Button>
                      </NavLink>
                    </div>
                  </div>
                  {openBets.length > 0 && loggedIn ? (
                    <ExchOpenBets />
                  ) : (
                    <>
                      <div className="no-bet-data">No open bets to show</div>
                    </>
                  )}
                </TabPanel>
              </AccordionDetails>
            </Accordion>
          </div>
        ) : null}
      </IonRow>
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    openBets: state.exchBetslip.openBets,
    totalOrders: state.exchBetslip.totalOrders,
    loggedIn: state.auth.loggedIn,
    secondaryMultiMarket: state.multiMarket.secondaryMultiMarketsMap,
    secondaryMultiMatchOdds: state.multiMarket.secondaryMultiMatchOddsMap,
    bets: state.exchBetslip.bets,
    marketData: state.multiMarket.multiMarketData,
    triggerFetchMarkets: state.multiMarket.triggerFetchMarkets,
    triggerFetchOrders: state.multiMarket.triggerFetchOrders,
    houseId: getHouseIdFromToken(),
    parentId: getParentIdFromToken(),
    accountId: sessionStorage.getItem('aid'),
    triggerBetStatus: state.multiMarket.triggerBetStatus,
    betStatusResponse: state.exchBetslip.betStatusResponse,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    fetchOpenBets: (eventId: string[] | string, sportId?: string) =>
      dispatch(fetchOpenBets(eventId, sportId)),
    fetchMultiMarketEventData: () => dispatch(fetchMultiMarketEventData()),
    clearExchangeBets: () => dispatch(clearExchcngeBets()),
    setBettingInprogress: (val: boolean) => dispatch(setBettingInprogress(val)),
    clearBetStatusResponse: () => dispatch(clearBetStatusResponse()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MultiMarketView);
